// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"07720e46","311":"a65aa057"}[chunkId] + ".chunk.js";
};